import React from 'react';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

export const Button = styled.span`
  background-color: ${themeGet('colors.primary.100')};
  background-image: none;
  border-radius: 8px;
  border: 1px solid ${themeGet('colors.primary.100')};
  box-shadow: none;
  color: white;
  cursor: pointer;
  display: inline-block;
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  font-weight: normal;
  font-weight: normal;
  letter-spacing: normal;
  line-height: 12px;
  line-height: normal;
  margin-bottom: 0;
  overflow: hidden;
  padding: 8px 20px;
  text-align: center;
  text-align: center;
  text-transform: capitalize;
  user-select: none;
  -ms-user-select: none;
  vertical-align: middle;
  white-space: nowrap;
  transition: all 0.2s ease-in-out;
  min-width: 80px;

  &:hover {
    color: white;
    background-color: ${themeGet('colors.primary.80')};
    border-color: ${themeGet('colors.primary.80')};
  }

  &:active {
    color: white;
    background-color: ${themeGet('colors.primary.120')};
    border: 1px solid ${themeGet('colors.primary.120')};
  }
`;

export const ButtonOutlined = styled(Button)`
  color: ${themeGet('colors.black.80')};
  background-color: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.black.20')};

  &:hover {
    background-color: ${themeGet('colors.black.60')};
    border-color: ${themeGet('colors.black.60')};
    color: white;
  }

  &:active {
    color: white;
    background-color: ${themeGet('colors.black.80')};
    border-color: ${themeGet('colors.black.80')};
  }
`;

export const ButtonContainer = styled.li`
  display: inline-block;
  float: left;
  cursor: pointer;
  margin-left: 10px !important;
`;

export const RightButtonContainer = styled(ButtonContainer)`
  margin-left: 8px !important;
`;

export const AcceptButton = ({ onClickAction }) => (
  <RightButtonContainer
    onClick={e => {
      e.stopPropagation();
      onClickAction(e);
    }}
    data-action="accept"
  >
    <Button data-action="accept" variant="containedBlue">
      Accept
    </Button>
  </RightButtonContainer>
);

export const IgnoreButton = ({ onClickAction }) => (
  <ButtonContainer
    onClick={e => {
      e.stopPropagation();
      onClickAction(e);
    }}
    data-action="ignore"
  >
    <ButtonOutlined data-action="ignore">Ignore</ButtonOutlined>
  </ButtonContainer>
);

export const UndoIgnoreButton = ({ onClickAction }) => (
  <ButtonContainer
    onClick={e => {
      e.stopPropagation();
      onClickAction(e);
    }}
    data-action="ignore"
  >
    <ButtonOutlined data-action="ignore">Undo Ignore</ButtonOutlined>
  </ButtonContainer>
);
